import { Button, FlexBox, FormError, FormField, FormInputGroup, Icon, StandardForm, TextArea, Typography } from '@vp/swan';
import React, { useState } from 'react';

export interface IFeedbackPopoverProps {
  popoverDisplayData?: {
    heading?: string;
    description?: string;
    placeholder?: string;
    sendButtonText?: string;
    cancelButtonText?: string;
  };
  popoverType?: 'popover' | 'embed';
  showCancelButton?: boolean;
  onClose: () => void;
  onSendFeedback: (feedbackMessage: string) => void;
  id?: string;
}

const FeedbackPopover: React.FC<IFeedbackPopoverProps> = ({
  onClose,
  onSendFeedback,
  popoverType = 'popover',
  popoverDisplayData,
  showCancelButton = true,
  id,
}) => {
  const [feedbackMessage, setFeedbackMessage] = useState<string>('');
  const [error, setError] = useState<string>('');

  const handleFeedbackChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFeedbackMessage(e.target.value);
    if (e.target.value.trim()) {
      setError('');
    }
  };

  const handleSendFeedback = () => {
    if (!feedbackMessage.trim()) {
      setError('Feedback is required');
      return;
    }
    onSendFeedback(feedbackMessage);
    setFeedbackMessage('');
    setError('');
  };

  return (
    <FlexBox flexDirection="column" gap="between-actions" id={id}>
      <FlexBox justifyContent="space-between" marginBottom={2}>
        <Typography fontSkin="body-standard-bold" textAlign={popoverType === 'embed' ? 'center' : 'standard'} style={{ flexGrow: 1 }}>
          {popoverDisplayData?.heading || 'Help us improve'}
        </Typography>
        {showCancelButton && (
          <Button skin="tertiary" onClick={onClose} p={4}>
            <Icon iconType="close" />
          </Button>
        )}
      </FlexBox>

      <Typography marginBottom={2} fontSkin="body-small">
        {popoverDisplayData?.description || `Every bit of feedback makes the Vista Assistant better. What didn't work as expected?`}
      </Typography>

      <StandardForm>
        <FormField>
          <FormInputGroup>
            <TextArea onChange={handleFeedbackChange} fullWidth value={feedbackMessage} placeholder={popoverDisplayData?.placeholder || ''} />
            {error && <FormError>{error}</FormError>}
          </FormInputGroup>
        </FormField>
      </StandardForm>

      {showCancelButton ? (
        <FlexBox flexDirection="row" justifyContent="flex-end" gap="between-actions">
          <Button marginBottom={2} onClick={onClose}>
            {popoverDisplayData?.cancelButtonText || 'Cancel'}
          </Button>
          <Button marginBottom={2} onClick={handleSendFeedback} skin="primary">
            {popoverDisplayData?.sendButtonText || 'Send'}
          </Button>
        </FlexBox>
      ) : (
        <FlexBox justifyContent={'space-around'} alignItems={'center'}>
          <Button marginBottom={2} onClick={handleSendFeedback} skin="primary" disabled={!feedbackMessage.trim()}>
            {popoverDisplayData?.sendButtonText || 'Send'}
          </Button>
        </FlexBox>
      )}
    </FlexBox>
  );
};

export default FeedbackPopover;
